import { useRef, useEffect } from 'react'
import Modal from './Modal'
import { Button } from '../generic/Core'
import useTranslation from '../../hooks/useTranslation'
import { FlexBox } from '../generic/Layout'
import { AlertIcon } from '../toast/Alert'
import {P} from '../generic/Core'
import styled, { useTheme } from 'styled-components'

const AlertTitle = styled.h3`
  margin-top: 0.25rem;
  margin-bottom: 0rem;
`




function Alert({ title, message, onClose, type = 'warning' }) {
  const { t } = useTranslation()
  const closeBtnRef = useRef(null)

  const theme = useTheme()
  const colors = theme.emotive[type] || theme.emotive.warning

  useEffect(() => {
    // Focus the close button when the alert is shown
    if (closeBtnRef.current) {
      closeBtnRef.current.focus()
    }
  }, [])

  return (
    <Modal $color={colors.color} $bg={colors.surface} $border={colors.border} setShow={onClose} show={true} mode=''>
      <Modal.Header $color={colors.color} setShow={onClose}>
        <FlexBox>
          <AlertIcon type={type} />
          <AlertTitle>{t(title)}</AlertTitle>
        </FlexBox>
      </Modal.Header>
      <Modal.Body>
        <P>{t(message)}</P> 
      </Modal.Body>
      <Modal.Footer $color={colors.color}>
        <Button 
          ref={closeBtnRef} 
          onClick={onClose}
          data-testid="alert-close-button"
          $variant = 'custom'
          $bg = {colors.color}
          $color = {theme.form.background}
        >
          {t('all.form.button.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default Alert
